import React from "react"
import { FormProvider, type UseFormReturn } from "react-hook-form"

const FormForm = <TFieldValues extends Record<string, any>>(
  props: React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement> & {
    formMethods: UseFormReturn<TFieldValues>
  }
) => {
  const { formMethods, ...formProps } = props

  return (
    <form {...formProps}>
      <FormProvider {...formMethods}>{props.children}</FormProvider>
    </form>
  )
}

export default FormForm
